<ng-container *ngIf="isMobile; else desktop">
  <app-mobile-filter-magic-cont
    [hasFilterSelected]="hasActiveFilter"
    [heightClass]="modalHeight"
    (clear)="clearFilters()">
    <ng-container body="body" *ngTemplateOutlet="filterList"></ng-container>
  </app-mobile-filter-magic-cont>
</ng-container>

<ng-template #filterList>
  <div [style.order]="0">
    <app-sorter-filter
      [label]="'HOTELS_MODULE.RESULT_HOTELS.SORTER_LABEL'"
      (sorter)="sorter.emit($event)"
      [sorters]="sorters"
      [isMobile]="isMobile"
      [pickedSorter]="pickedSorter">
    </app-sorter-filter>
  </div>

  <app-checkbox-filter
    *ngIf="isByHours"
    [options]="byHoursFilter.value"
    [pickedCheckboxes]="hourType"
    [type]="byHoursFilter.type"
    [isMobile]="isMobile"
    (filter)="applyByHoursFilter($event)"
    [label]="getItemLabel(byHoursFilter.type)"
    [isOpenBox]="true">
  </app-checkbox-filter>

  <div *ngFor="let filter of filters; index as i; trackBy: trackById" [style.order]="filterOrder(filter)">
    <app-checkbox-filter
      *ngIf="isCheckboxFilter(filter)"
      [options]="filter.value"
      [pickedCheckboxes]="pickedCheckboxes"
      [type]="filter.type"
      [index]="i"
      [isMobile]="isMobile"
      (filter)="applyCheckboxFilter($event)"
      [label]="getItemLabel(filter.type)"
      [isOpenBox]="true">
    </app-checkbox-filter> 

    <app-radio-filter
      *ngIf="isRadioFilter(filter)"
      [options]="filter.value"
      [pickedTotalDiscountPercentage]="pickedTotalDiscountPercentage"
      [type]="filter.type"
      [index]="i"
      [isMobile]="isMobile"
      (filter)="applyCheckboxFilter($event)"
      [label]="getItemLabel(filter.type)"
      [isOpenBox]="true">
    </app-radio-filter>
    
    <app-range-input-filter
      *ngIf="isRangeFilter(filter)"
      [index]="i"
      [isHotels]="true"
      [type]="filter.type"
      [pickedRanges]="pickedRanges"
      [min]="filter.value.min"
      [max]="filter.value.max"
      (values)="applyFilter(filter.type, $event)"
      [label]="getItemLabel(filter.type)"
      [isOpenBox]="true">
    </app-range-input-filter>

    <app-stars-filter
      *ngIf="isStarsFilter(filter)"
      [index]="i"
      [list]="filter.value"
      [pickedStars]="pickedStars"
      (selectStar)="applyFilter(filter.type, $event)"
      [isClear]="isClearSelectedStars"
      (clearSelectedItems)="clearSelectedStars(false)"
      [label]="getItemLabel(filter.type) | transloco">
    </app-stars-filter>

    <app-input-filter
      *ngIf="isInputFilter(filter)"
      [index]="i"
      [options]="filter.value"
      [value]="hotelNameSearch"
      [placeholder]="getPlaceholderToItem(filter.type) | transloco"
      [label]="getItemLabel(filter.type) | transloco"
      [labelBySearch]="'HOTELS_MODULE.FILTER_HOTELS.VIEW_HOTELS_NAME'"
      [isOpenBox]="true"
      [isMobile]="isMobile"
      (changeHotelName)="applyFilter(filter.type, $event)">
    </app-input-filter>

    <app-exclusive-offer-filter
      *ngIf="isExclusiveOfferFilter(filter)"
      [isOpenBox]="true"
      [isMobile]="isMobile"
      [index]="i"
      [filterExclusive]="filter"
      [hasRappiCard]="hasRappiCard$ | async"
      [isPrime]="isPrime$ | async"
      [exclusiveOffer]="exclusiveOffer"
      [source]="source"
      (filter)="applyCheckboxFilter($event)">
    </app-exclusive-offer-filter>
  </div>
</ng-template>

<ng-template #desktop>
  <ng-container *ngTemplateOutlet="filterList"></ng-container>
</ng-template>
